import React, { useRef, useContext } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import axios from 'axios';
import { getHeaders } from '../../request';
import Imagens from '../anexos/imagens';
import { SITUACAO_LAUDO } from './constantes';
import { temPermissaoRBAC, temPermissaoRede } from '../../security/acl';
import Priorizar from './priorizar';
import Invalidar from './invalidar';
import { CONSTANTE_DESCRICAO_ENVIO_EXAMES_COMPARACAO_SONO_HABITUAL, CONSTANTE_DESCRICAO_ENVIO_EXAMES_GRAU_DESCONFORTO, CONSTANTE_DESCRICAO_POSSUI_MOVIMENTOS_REPETIDOS_DESCONFORTO_PERNAS, CONSTANTE_DESCRICAO_SOLICITACAO_POSSUI_RONCO, CONSTANTE_DESCRICAO_SOLICITACAO_SENTE_SONOLENCIA, PERMISSOES } from '../../common/Constants';
import {
    SttTextItem,
    SttCircularProgress,
    SttGrid,
    SttNotification,
    SttAlertTitle,
    SttTranslateHook,
    SttHidden,
    SttText,
    SttCtrlP
} from '@stt-componentes/core';
import {
    SttTable,
    SttTableHead,
    SttTableBody,
    SttTableRow,
    SttTableCell
} from '@stt-componentes/core-v2';
import { SttContentDrawer } from '@stt-componentes/core-v2';
import usuario from '../../signals/usuario';
import { useSignal, useSignalEffect, useSignals } from '@preact/signals-react/runtime';
import alerta from '../../signals/alerta';
import { NotificationManager } from 'react-notifications';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import Tooltip from '@material-ui/core/Tooltip';
import { SECOES, REACT_KEYS } from './fieldNames';

const useStyles = makeStyles(theme => ({
    carregando: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        width: '100%'
    },
    notificationContent: {
        display: 'flex',
        flexDirection: 'column'
    },
    notification: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
    },
    protocolo: {
        display: 'flex',
        gap: theme.spacing(2),
        alignItems: 'center'
    },
    fileCopyIcon: {
        fontSize: '1.2em',
        cursor: 'pointer',
        color: '#0A6FB8'
    }
}));

const DadosExame = (props) => {
    useSignals();

    const { id, imprimirFn, imprimirProtocoloFn, imprimirTermoFn, voltarFn, ocultarBotoes = false } = props;

    const exame = useSignal(null);
    const anexosExame = useSignal(null);
    const priorizar = useSignal(false);
    const invalidar = useSignal(false);
    const permissaoBtns = useSignal([]);
    const textoTooltip = useSignal([]);

    const classes = useStyles();
    const { strings } = useContext(SttTranslateHook.I18nContext);
    const drawerRef = useRef();

    const POLISSONO_API_BASE_URL = global.gConfig.url_base_polissonografia;

    useSignalEffect(() => {
        if (usuario.value.perfisRBAC && exame.value) {
            let rede;
            usuario.value.perfisRBAC.forEach(p => {
                p.redes && p.redes.forEach(r => {
                    if (r.id === exame.value.exame.id_rede_telemedicina) {
                        rede = r;
                    }
                });
            });
            if (rede) {
                permissaoBtns.value = [
                    temPermissaoRede(rede[0], PERMISSOES.INVALIDAR_EXAME),
                    temPermissaoRede(rede[0], PERMISSOES.PRIORIZAR_EXAME)
                ];
            }
        }
    });

    useSignalEffect(() => {
        if (id) {
            axios
                .get(`${POLISSONO_API_BASE_URL}/exame/${id}`, { headers: getHeaders() })
                .then((response) => {
                    const { data } = response;
                    exame.value = data;
                    anexosExame.value = data.arquivos;
                })
                .catch(err => {
                    const { response } = err;
                    let msg = strings.mensagemErroGeral;
                    let titulo = strings.erro;
                    let arrMensagem = [];
                    if (response) {
                        const { data } = response;
                        titulo = data.message;
                        data.errors.forEach(error => {
                            arrMensagem.push(`- ${error.message}`);
                        });
                        msg = arrMensagem.join('\n');
                    }

                    const alertConfig = {
                        title: titulo,
                        message: msg,
                        type: 'error',
                        open: true,
                        options: [
                            {
                                title: strings.ok,
                                onClick: () => {
                                    alerta.value = {
                                        ...alerta.value,
                                        open: false
                                    };
                                    voltarFn();
                                }
                            }
                        ],
                        onClose: () => {
                            alerta.value = {
                                ...alerta.value,
                                open: false
                            };
                            voltarFn();
                        }
                    };
                    alerta.value = alertConfig;
                });
        }
    })

    const callbackImpedirImpressao = () => {
        if (exame.value.exame.valido) {
            imprimirFn(id);
        } else {
            NotificationManager.error(strings.impressaoDesabilitada);
        }
    };


    return (
        <>
            <>
                {!exame.value
                    ? (
                        <div className={classes.carregando}>
                            <SttCircularProgress color="primary" />
                        </div>
                    ) : (
                        <>
                            <SttCtrlP callback={callbackImpedirImpressao} />
                            <SttContentDrawer
                                titulo={exame.value.exame.descricao_exame}
                                onClickVoltar={voltarFn}
                                ref={drawerRef}
                                secoesErro={[SECOES.DADOS_DO_PACIENTE, SECOES.DADOS_DO_EXAME, SECOES.INDICACAO_CLINICA, SECOES.DADOS_DO_SONO, SECOES.OUTRAS_INFORMACOES, SECOES.LAUDO]}
                                botoes={[
                                    {
                                        key: REACT_KEYS.BTN_IMPRIMIR,
                                        descricao: strings.imprimir,
                                        type: 'button',
                                        variant: 'contained',
                                        color: 'primary',
                                        show: exame.value.exame.valido,
                                        onClick: () => imprimirFn(id),
                                    },
                                    {
                                        key: REACT_KEYS.BTN_PROTOCOLO,
                                        descricao: strings.protocolo,
                                        type: 'button',
                                        variant: 'contained',
                                        color: 'secondary',
                                        show: exame.value.exame.valido,
                                        onClick: () =>
                                            imprimirProtocoloFn({
                                                ...exame.value.exame,
                                                id: exame.value.exame.id_exame,
                                            }),
                                    },
                                    {
                                        key: REACT_KEYS.BTN_TERMO,
                                        descricao: strings.imprimirTermo,
                                        type: 'button',
                                        variant: 'contained',
                                        color: 'secondary',
                                        show: exame.value.exame.valido,
                                        onClick: () => imprimirTermoFn(exame.value.exame),
                                    },
                                    {
                                        key: REACT_KEYS.BTN_PRIORIZAR,
                                        descricao: strings.priorizar,
                                        type: 'button',
                                        variant: 'contained',
                                        color: 'secondary',
                                        show:
                                            (permissaoBtns.value[1] ||
                                                (permissaoBtns.value[1] === undefined &&
                                                    temPermissaoRBAC(usuario, PERMISSOES.PRIORIZAR_EXAME))) &&
                                            exame.value.exame.situacao_laudo === SITUACAO_LAUDO.SEM_LAUDO &&
                                            exame.value.exame.valido,
                                        onClick: () => (priorizar.value = true),
                                    },
                                    {
                                        key: REACT_KEYS.BTN_INVALIDAR,
                                        descricao: strings.invalidar,
                                        type: 'button',
                                        variant: 'contained',
                                        color: 'secondary',
                                        show:
                                            (((permissaoBtns.value[0] ||
                                                (permissaoBtns.value[0] === undefined &&
                                                    temPermissaoRBAC(usuario, PERMISSOES.INVALIDAR_EXAME))) &&
                                                exame.value.exame.situacao_laudo === SITUACAO_LAUDO.SEM_LAUDO) ||
                                                (temPermissaoRBAC(
                                                    usuario,
                                                    PERMISSOES.INVALIDAR_EXAME_LAUDADO
                                                ) &&
                                                    exame.value.exame.situacao_laudo === SITUACAO_LAUDO.COM_LAUDO)) &&
                                            exame.value.exame.valido,
                                        onClick: () => (invalidar.value = true),
                                    },
                                ]}
                                conteudo={[
                                    {
                                        key: REACT_KEYS.SEC_DADOS_DO_PACIENTE,
                                        id: SECOES.DADOS_DO_PACIENTE,
                                        titulo: strings.paciente,
                                        show: true,
                                        children: (
                                            <div>
                                                <SttTextItem title={strings.nome} content={exame.value.exame.nome_paciente} />
                                                <SttTextItem title={strings.dataNascimento} content={exame.value.exame.data_nascimento_paciente_formatada} />
                                                <SttTextItem title={strings.sexo} content={exame.value.exame.sexo_paciente} />
                                                {exame.value.indicacao?.peso_paciente && <SttTextItem title={strings.peso} content={`${exame.value.indicacao.peso_paciente} kg`} />}
                                                {exame.value.indicacao?.altura_paciente && <SttTextItem title={strings.altura} content={`${exame.value.indicacao.altura_paciente} cm`} />}
                                                <SttTextItem title={strings.idade} content={`${exame.value.exame.idade_paciente}`} />
                                                {exame.value.exame.cartao_sus_paciente && <SttTextItem title={strings.cns} content={exame.value.exame.cartao_sus_paciente} />}
                                            </div>
                                        ),
                                    },
                                    {
                                        key: REACT_KEYS.SEC_DADOS_DO_EXAME,
                                        id: SECOES.DADOS_DO_EXAME,
                                        titulo: strings.dadosExame,
                                        show: true,
                                        children: (
                                            <div>
                                                <SttTextItem title={strings.modalidade} content={exame.value.exame.descricao_modalidade} />
                                                <SttTextItem title={strings.dataExame} content={`${exame.value.exame.data_exame} ${global.gConfig.sufixo_data_hora}`} />
                                                <div className={classes.protocolo}>
                                                    <SttTextItem title={strings.protocolo} content={exame.value.exame.protocolo_rctm} />
                                                    <Tooltip
                                                        title={textoTooltip.value}
                                                        arrow
                                                        onClick={() => {
                                                            navigator.clipboard.writeText(exame.value.exame.protocolo_rctm);
                                                            textoTooltip.value = strings.protocoloCopiado;
                                                        }}
                                                        onClose={() => {
                                                            textoTooltip.value = strings.copiar;
                                                        }}
                                                    >
                                                        <FileCopyIcon className={classes.fileCopyIcon} />
                                                    </Tooltip>
                                                </div>
                                                <SttTextItem title={strings.requisicao} content={exame.value.exame.requisicao} />
                                                <SttTextItem title={strings.instituicao} content={exame.value.exame.nome_instituicao} />
                                                <SttTextItem title={strings.medicoSolicitante} content={exame.value.exame.nome_medico_solicitante} />
                                                {exame.value.exame.nome_medico_executor && <SttTextItem title={strings.medicoExecutor} content={exame.value.exame.nome_medico_executor} />}
                                            </div>
                                        ),
                                    },
                                    {
                                        key: REACT_KEYS.SEC_INDICACAO_CLINICA,
                                        id: SECOES.INDICACAO_CLINICA,
                                        titulo: strings.indicacaoClinica,
                                        show: !!exame.value.indicacao,
                                        children: (
                                            <div>
                                                {exame.value.indicacao?.demora_iniciar_sono !== null && <SttTextItem title={strings.demoraIniciarSono} content={exame.value.indicacao?.demora_iniciar_sono ? `${strings.sim}, nos(as) últimos(as) ${exame.value.indicacao?.tempo_demora_iniciar_sono} ${exame.value.indicacao?.especificacao_tempo_demora_iniciar_sono}` : strings.nao} />}
                                                {exame.value.indicacao?.possui_despertares_meio_sono !== null && <SttTextItem title={strings.variosDespertaresMeioSono} content={exame.value.indicacao?.possui_despertares_meio_sono ? `${strings.sim}, nos(as) últimos(as) ${exame.value.indicacao?.tempo_despertares_meio_sono} ${exame.value.indicacao?.especificacao_tempo_despertares_meio_sono}` : strings.nao} />}
                                                {exame.value.indicacao?.desperta_cedo_demais !== null && <SttTextItem title={strings.despertaCedoDemais} content={exame.value.indicacao?.desperta_cedo_demais ? `${strings.sim}, nos(as) últimos(as) ${exame.value.indicacao?.tempo_desperta_cedo_demais} ${exame.value.indicacao?.especificacao_tempo_desperta_cedo_demais}` : strings.nao} />}
                                                {exame.value.indicacao?.intensidade_sonolencia_fadiga && <SttTextItem title={strings.tituloSenteSonolenciaDuranteDia} content={CONSTANTE_DESCRICAO_SOLICITACAO_SENTE_SONOLENCIA(strings, exame.value.indicacao?.intensidade_sonolencia_fadiga)} />}
                                                {exame.value.indicacao?.possui_ronco && <SttTextItem title={strings.tituloRonca} content={CONSTANTE_DESCRICAO_SOLICITACAO_POSSUI_RONCO(strings, exame.value.indicacao?.possui_ronco)} />}
                                                {exame.value.indicacao?.possui_dificuldade_respirar != null && <SttTextItem title={strings.tituloRelatouDificuldadeRespirar} content={exame.value.indicacao?.possui_dificuldade_respirar ? strings.sim : strings.nao} />}
                                                {exame.value.indicacao?.possui_movimentos_repetidos_involuntarios && <SttTextItem title={strings.movimentosRepetidosDuranteSono} content={CONSTANTE_DESCRICAO_POSSUI_MOVIMENTOS_REPETIDOS_DESCONFORTO_PERNAS(strings, exame.value.indicacao?.possui_movimentos_repetidos_involuntarios)} />}
                                                {exame.value.indicacao?.possui_desconforto_pernas && <SttTextItem title={strings.desconfortoPernas} content={CONSTANTE_DESCRICAO_POSSUI_MOVIMENTOS_REPETIDOS_DESCONFORTO_PERNAS(strings, exame.value.indicacao?.possui_desconforto_pernas)} />}
                                                {exame.value.indicacao?.problemas_saude && <SttTextItem title={strings.problemasSaude} content={exame.value.indicacao?.problemas_saude} />}

                                                {
                                                    exame.value.indicacao?.medicamentos?.length > 0 &&
                                                    <SttTable>
                                                        <SttTableHead>
                                                            <SttTableRow>
                                                                <SttHidden smDown>
                                                                    <SttTableCell width="30%">
                                                                        {strings.medicamento}
                                                                    </SttTableCell>
                                                                    <SttTableCell width="70%">
                                                                        {strings.motivo}
                                                                    </SttTableCell>
                                                                </SttHidden>
                                                                <SttHidden mdUp>
                                                                    <SttTableCell width="100%" colSpan="2">{strings.medicamentos}</SttTableCell>
                                                                </SttHidden>
                                                            </SttTableRow>
                                                        </SttTableHead>
                                                        <SttTableBody>
                                                            {
                                                                exame.value.indicacao.medicamentos.map((row, index) => (
                                                                    <SttTableRow key={index}>
                                                                        <SttHidden smDown>
                                                                            <SttTableCell>{row.medicamento}</SttTableCell>
                                                                            <SttTableCell>{row.motivo}</SttTableCell>
                                                                        </SttHidden>
                                                                        <SttHidden mdUp>
                                                                            <SttTableCell width="96%">
                                                                                <SttText size="small">
                                                                                    <b>{strings.medicamento}:</b> {row.medicamento}
                                                                                </SttText>
                                                                                <SttText size="small">
                                                                                    <b>{strings.motivo}:</b> {row.motivo}
                                                                                </SttText>
                                                                            </SttTableCell>
                                                                        </SttHidden>
                                                                    </SttTableRow>
                                                                ))
                                                            }
                                                        </SttTableBody>
                                                    </SttTable>
                                                }
                                            </div>
                                        ),
                                    },
                                    {
                                        key: REACT_KEYS.SEC_DADOS_DO_SONO,
                                        id: SECOES.DADOS_DO_SONO,
                                        titulo: strings.dadosExame,
                                        show: !!exame.value.exame && (
                                            exame.value.exame.observacao ||
                                            exame.value.exame.grau_desconforto_aparelho_polissonografia ||
                                            exame.value.exame.hora_adormecer ||
                                            exame.value.exame.tempo_demora_iniciar_sono ||
                                            exame.value.exame.quantidade_despertou_noite ||
                                            exame.value.exame.tempo_dormiu_noite ||
                                            exame.value.exame.grau_comparacao_sono_habitual ||
                                            exame.value.exame.especificacao_causa_desconforto
                                        ),
                                        children: (
                                            <div>
                                                {exame.value.exame.observacao && <SttTextItem title={strings.observacao} content={exame.value.exame.observacao} />}
                                                {exame.value.exame.grau_desconforto_aparelho_polissonografia && <SttTextItem title={strings.grauDesconfortoAparelhoPolissonografia} content={CONSTANTE_DESCRICAO_ENVIO_EXAMES_GRAU_DESCONFORTO(strings, exame.value.exame.grau_desconforto_aparelho_polissonografia)} />}
                                                {exame.value.exame.hora_adormecer && <SttTextItem title={strings.horasDeitouDormir} content={`${exame.value.exame.hora_adormecer.hours} hora(s) e ${exame.value.exame.hora_adormecer.minutes ? exame.value.exame.hora_adormecer.minutes : '00'} minuto(s).`} />}
                                                {exame.value.exame.tempo_demora_iniciar_sono && <SttTextItem title={strings.tempoDemorouIniciarSono} content={`${exame.value.exame.tempo_demora_iniciar_sono.hours} hora(s) e ${exame.value.exame.tempo_demora_iniciar_sono.minutes ? exame.value.exame.tempo_demora_iniciar_sono.minutes : '00'} minuto(s).`} />}
                                                {exame.value.exame.quantidade_despertou_noite && <SttTextItem title={strings.vezesDespertouDuranteNoite} content={exame.value.exame.quantidade_despertou_noite} />}
                                                {exame.value.exame.tempo_dormiu_noite && <SttTextItem title={strings.tempoAchaDormiuEstaNoite} content={`${exame.value.exame.tempo_dormiu_noite.hours} hora(s) e ${exame.value.exame.tempo_dormiu_noite.minutes ? exame.value.exame.tempo_dormiu_noite.minutes : '00'} minuto(s).`} />}
                                                {exame.value.exame.grau_comparacao_sono_habitual && <SttTextItem title={strings.comparadoSonoHabitualSonoNoite} content={CONSTANTE_DESCRICAO_ENVIO_EXAMES_COMPARACAO_SONO_HABITUAL(strings, exame.value.exame.grau_comparacao_sono_habitual)} />}
                                                {exame.value.exame.especificacao_causa_desconforto && <SttTextItem title={strings.descricaoCausasDesconforto} content={exame.value.exame.especificacao_causa_desconforto} />}
                                            </div>
                                        ),
                                    },
                                    {
                                        key: REACT_KEYS.SEC_OUTRAS_INFORMACOES,
                                        id: SECOES.OUTRAS_INFORMACOES,
                                        titulo: strings.outrasInformacoes,
                                        show: !!exame.value.exame.observacao_tecnica?.trim(),
                                        children: (
                                            <div>
                                                {exame.value.exame.observacao_tecnica && <SttTextItem title={strings.observacaoTecnica} content={exame.value.exame.observacao_tecnica} />}
                                            </div>
                                        ),
                                    },
                                    {
                                        key: REACT_KEYS.SEC_LAUDO,
                                        id: SECOES.LAUDO,
                                        titulo: strings.laudo,
                                        show: temPermissaoRBAC(usuario, PERMISSOES.VISUALIZAR_LAUDO) && exame.value.laudo,
                                        children: (
                                            <div dangerouslySetInnerHTML={{ __html: exame.value.laudo }}></div>
                                        ),
                                    },
                                    {
                                        key: REACT_KEYS.SEC_INVALIDO,
                                        id: SECOES.INVALIDO,
                                        titulo: strings.exameInvalidado,
                                        show: !exame.value.exame.valido,
                                        children: (
                                            <SttNotification severity="info" className={classes.notification}>
                                                <SttAlertTitle>{strings.exameInvalidado}</SttAlertTitle>
                                                <div className={classes.notificationContent}>
                                                    <span>{`${strings.motivo}: ${exame.value.exame.motivo_invalidacao}`}</span>
                                                    <span>{`${strings.responsavel}: ${exame.value.exame.responsavel_invalidacao}`}</span>
                                                    <span>{`${strings.data}: ${exame.value.exame.data_invalidacao} ${global.gConfig.sufixo_data_hora}`}</span>
                                                </div>
                                            </SttNotification>
                                        ),
                                    },
                                    {
                                        key: REACT_KEYS.SEC_IMAGENS,
                                        id: SECOES.IMAGENS,
                                        titulo: strings.imagens,
                                        show: temPermissaoRBAC(usuario, PERMISSOES.VISUALIZAR_IMAGEM),
                                        children: (
                                            <Imagens idExame={id} anexos={anexosExame} />
                                        ),
                                    }
                                ]}
                            />
                            {
                                (permissaoBtns.value[1] ||
                                    (permissaoBtns.value[1] === undefined && temPermissaoRBAC(usuario, PERMISSOES.PRIORIZAR_EXAME))) &&
                                priorizar && exame.value.exame.situacao_laudo === SITUACAO_LAUDO.SEM_LAUDO && exame.value.exame.valido &&
                                <Priorizar
                                    priorizar={priorizar}
                                    idExame={id}
                                    idInstituicao={exame.value.exame.id_instituicao}
                                    callback={voltarFn}
                                />
                            }
                            {
                                (((permissaoBtns.value[0] ||
                                    (permissaoBtns.value[0] === undefined && temPermissaoRBAC(usuario, PERMISSOES.INVALIDAR_EXAME))) &&
                                    exame.value.exame.situacao_laudo === SITUACAO_LAUDO.SEM_LAUDO) ||
                                    (temPermissaoRBAC(usuario, PERMISSOES.INVALIDAR_EXAME_LAUDADO) &&
                                        exame.value.exame.situacao_laudo === SITUACAO_LAUDO.COM_LAUDO)) &&
                                invalidar &&
                                exame.value.exame.valido &&
                                <Invalidar
                                    invalidar={invalidar}
                                    idExame={id}
                                    idInstituicao={exame.value.exame.id_instituicao}
                                    idModalidade={exame.value.exame.id_modalidade}
                                    callback={voltarFn}
                                />
                            }
                        </>
                    )
                }
            </>
        </>
    );
};

export default DadosExame;
